import { useNavigate, useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import EmojiPeople from '@mui/icons-material/EmojiPeople';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import { EditCustomerInput, RegisteredCustomerInput } from '__generated__/graphql';
import { Loading, LocationBar } from 'components';
import { useGetCustomer, useEditCustomer } from 'api/hooks/useCustomer';
import { useToastNofication } from 'context/toastContext';
import { CustomerActivateButton } from './CustomerActivateButton';
import { CustomerForm } from './CustomerForm';

function CustomerUpdateForm() {
  const { customerId } = useParams();
  const navigate = useNavigate();
  const { addToast } = useToastNofication();

  const { editCustomer, editCustomerLoading, editCustomerError } = useEditCustomer();
  const onSubmit = async (input: RegisteredCustomerInput | EditCustomerInput) => {
    const response = await editCustomer({
      variables: {
        input,
      },
    });
    addToast(response, 'EditCustomer');

    if (!editCustomerLoading && !editCustomerError) {
      navigate('/customers');
    }
  };

  const { customer, customerLoading } = useGetCustomer(customerId);

  if (customerLoading) {
    return <Loading />;
  }

  return (
    <>
      <Helmet>
        <title>Customer Update</title>
      </Helmet>
      <LocationBar section="Customer" page="Customer Update Form" Icon={EmojiPeople} />
      <div className="my-10 px-4 md:px-[5%]">
        <button
          data-cy="form-detail-back"
          type="button"
          className="text-gray-500 font-semibold text-md leading-md flex items-center"
          onClick={() => {
            navigate('/customers');
          }}
        >
          <ArrowLeftIcon className="mr-2 w-5 h-5" /> Back
        </button>
        <div className="mt-10 sm:mt-16">
          <div className=" items-start justify-between mt-8 flex flex-col	 lg:flex-row xl:flex-row">
            {customer?.id && <CustomerActivateButton id={customer?.id} isActive={customer.isActive} />}
          </div>
          <CustomerForm customer={customer} onSubmit={onSubmit} formSubmitting={editCustomerLoading} formSubmitError={editCustomerError} />
        </div>
      </div>
    </>
  );
}

export default CustomerUpdateForm;
